

import { Component, Vue } from "vue-property-decorator";

export default Vue.extend({
  name: "myFooter",
  components: {
    
  },
});


